export default function Camera() {
    return (
        <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M5.93103 26.5639C5.36722 26.5639 4.91016 26.1068 4.91016 25.543V10.5703C4.91016 10.0064 5.36722 9.54939 5.93103 9.54939H11.5922L13.5173 6.60827C13.7059 6.32012 14.0271 6.14648 14.3715 6.14648H19.9497C20.2941 6.14648 20.6153 6.32012 20.8039 6.60827L22.729 9.54939H28.3902C28.954 9.54939 29.4111 10.0064 29.4111 10.5703V25.543C29.4111 26.1068 28.954 26.5639 28.3902 26.5639H5.93103Z"
                stroke="black"
                strokeWidth="1.53131"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M17.1606 21.1191C19.4159 21.1191 21.2441 19.2909 21.2441 17.0356C21.2441 14.7804 19.4159 12.9521 17.1606 12.9521C14.9054 12.9521 13.0771 14.7804 13.0771 17.0356C13.0771 19.2909 14.9054 21.1191 17.1606 21.1191Z"
                stroke="black"
                strokeWidth="1.53131"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}
